export default "__VITE_ASSET__DDPXYjrY__"